/**
 * Payment Manager - Handles payment-related button interactions
 * Manages cancel subscription, one-click pay, and update subscription buttons
 */

(function() {
	'use strict';

	function selectedSubscription(subscriptionId) {
		subscriptionId = subscriptionId || window.user_properties?.subscription_id;

		return window.subscriptions.find(function(el){
			if (el.id == subscriptionId || el.pay_system_id == subscriptionId) {
				return el;
			}
		})
	}

	window.selectedSubscription = selectedSubscription;

	/**
	 * Handle failed action for upsell/update buttons
	 * @param {jQuery} $button - The button element
	 * @param {string} prefix - Data attribute prefix ('upsell' or 'update')
	 */
	function handleFailedAction($button, prefix = 'upsell') {
		let actionAttr, popupAttr, callbackAttr, redirectAttr;

		if (prefix === "update") {
			actionAttr = "data-update-failed-action";
			popupAttr = "data-update-failed-popup-id";
			callbackAttr = "data-update-failed-js-callback";
			redirectAttr = "data-update-failed-redirect-url";
		} else if (prefix === "timer-end") {
			actionAttr = "data-timer-end-action";
			popupAttr = "data-timer-end-popup-id";
			callbackAttr = "data-timer-end-js-callback";
			redirectAttr = "data-timer-end-redirect-url";
		} else {
			actionAttr = "data-upsell-failed-action";
			popupAttr = "data-upsell-failed-popup-id";
			callbackAttr = "data-upsell-failed-js-callback";
			redirectAttr = "data-upsell-failed-redirect-url";
		}

		let actionType = $button.attr(actionAttr);
		let popupId = $button.attr(popupAttr);
		let jsCallback = $button.attr(callbackAttr);
		let redirectUrl = $button.attr(redirectAttr);

		// Support JSON format for backward compatibility
		if (actionType && actionType.startsWith('{')) {
			try {
				let action = JSON.parse(actionType);
				actionType = action.action;
				popupId = action.popup_id || popupId;
				jsCallback = action.js_callback || jsCallback;
				redirectUrl = __(action.redirect_url || redirectUrl);
			} catch (e) {
				// If parsing fails, treat as regular action type
			}
		}

		if (!actionType) {
			return;
		}

		if (actionType === 'open_popup') {
			if (popupId) {
				// Open the specified popup
				setTimeout(() => {
					w2w.hideToast();
					// if ($('#' + popupId).length === 0) {
					// 	w2w.showToast('Popup not found', 'error');
					// }
					window.PopupInstance.open('#' + popupId);
				}, 1);
			} else {
				w2w.showToast('No Popup selected for this error', 'error');
			}
		} else if (actionType === 'hide_block') {
			// Hide timer block/container when countdown is finished
			$button.stop(true, true).slideUp(250, function () {
				$(this).hide();
			});
		} else if (actionType === 'js_callback') {
			if (jsCallback) {
				// Execute the JavaScript callback
				try {
					_eval(jsCallback);
				} catch (e) {
					w2w.showToast('Error executing callback', 'error');
					console.error('Error executing callback:', e);
				}
			} else {
				w2w.showToast('No JS callback defined for this error', 'error');
			}
		} else if (actionType === 'redirect') {
			if (redirectUrl) {
				w2w.hideToast();
				const url = __(redirectUrl);
				setTimeout(() => {
					window.location.href = url;
				}, 1);
			} else {
				w2w.showToast('No redirect URL defined for this error', 'error');
			}
		}
	}

	window.handleFailedAction = handleFailedAction;

	// ============================================================================
	// Cancel Subscription Button Handler
	// ============================================================================
	$(document).on('click', '[data-cancel-subscription-id]', function(e) {
		e.preventDefault();
		const $this = $(this);

		if ($this.hasClass('loading')) {
			return false;
		}

		let subscriptionId = $this.attr('data-cancel-subscription-id');
		if (!subscriptionId) {
			w2w.showToast(__('Please, set subscription ID for this button!'), 'error');
			return false;
		}

		let cancel_at_period_end = $this.attr('data-cancel_at_period_end');
		const cancelData = {
			pay_system_id: subscriptionId,
			comment: (window.user_properties && (window.user_properties.cancellation_reason || window.user_properties.reason)) || '',
			cancel_at_period_end: cancel_at_period_end == 'immediate' ? 0 : 1,
			test_project_id: window.project?.project_id,
		};

		$this.addClass('loading');

		$.ajax({
			url: '/api/subscription/cancel',
			type: 'PUT',
			data: cancelData,
			success: function(response) {
				w2w.logEvent('User Subscription Canceled', {
					value: subscriptionId,
					comment: cancelData.comment
				});

				w2w.showToast(response.message || __('Subscription canceled successfully'), 'success');

				$this.removeClass('loading');

				// Handle success action
				let successAction = $this.attr('data-cancel-success-action') || 'default';
				let successJsCallback = $this.attr('data-cancel-success-js-callback') || '';
				let successUrl = $this.attr('data-cancel-success-url') || '';

				if (successAction === 'js_callback' && successJsCallback) {
					// Execute the JavaScript callback
					try {
						_eval(successJsCallback);
					} catch (e) {
						w2w.showToast('Error executing callback', 'error');
						console.error('Error executing callback:', e);
					}
				} else if (successAction === 'url' && successUrl) {
					// Redirect to URL or Screen
					setTimeout(() => {
						// Check if it's a screen ID (starts with #) or a URL
						if (successUrl.startsWith('#')) {
							// It's a screen ID, navigate to it
							screensManager.moveToSection(successUrl.replace('#', ''), 'cancel_success');

							setTimeout(function() {
								location.reload();
							}, 600);
						} else {
							// It's a URL, redirect to it
							window.location.href = __(successUrl);
						}
					}, 100);
				} else {
					// Default behavior: go to next screen and reload page
					screensManager.moveToNextScreen();

					setTimeout(function() {
						location.reload();
					}, 600);
				}
			},
			error: function(xhr, status, error) {
				const json = xhr.responseJSON;
				const errorText = json?.error_msg || json?.message || error;
				w2w.showToast(errorText, 'error');

				w2w.logEvent('User Subscription Cancel Error', {
					value: errorText,
					status: status,
					cancelData: cancelData
				});

				console.error('Error cancelling subscription:', errorText);
				$this.removeClass('loading');
			}
		});

		return false;
	});

	// ============================================================================
	// One Click Pay Button Handler
	// ============================================================================
	$(document).on('click', '[data-one-click-price-id]', function(e) {
		e.preventDefault();
		const $this = $(this);

		if ($this.hasClass('loading')) {
			return false;
		}

		let priceId = $this.attr('data-one-click-price-id');
		if (!priceId) {
			w2w.showToast(__('Please, set price for this button!<br>If you see the message, contact to the administrator'), 'error');
			return false;
		}

		if (priceId == 'selected') {
			priceId = localStorage.getItem('price_id');
		}

		let payPalPriceId = $this.attr('data-one-click-paypal-price-id');
		if (payPalPriceId == 'selected') {
			payPalPriceId = getActivePriceInfo()?.paywall_price?.paypal_id;
		}

		$this.addClass('loading');

		const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

		let params = {
			_token: csrfToken,
			price_id: priceId,
			paypal_price_id: payPalPriceId,
			paywall_id: window.paywall_id || '',
			customer_email: user_properties.email || '',
			quiz_id: getParams('quiz_id') || (window.user_properties ? window.user_properties.last_quiz_id : '') || '',
			quiz_version: getParams('quiz_version') || '',
		};

		if (getParams('test_project_id')) {
			params.test_project_id = getParams('test_project_id');
		}

		if (localStorage.hasOwnProperty('paddle.last_transaction_id')) {
			const lastTransactionId = localStorage.getItem('paddle.last_transaction_id');
			if (lastTransactionId) {
				params.last_transaction_id = lastTransactionId;
			}
		}

		const paymentMethod = window.paymentMethod || 'stripe';

		if (paymentMethod == 'paddle') {

			// is one time price
			const oneClickPrice = window.paywall_products?.product_info?.product_data?.prices?.find(
				(price) => price.id == priceId
			);
			const isOneTimePrice = oneClickPrice && oneClickPrice.period_interval == 0;

			if (!isOneTimePrice) {

				// check load paddle form for subscription paddle
				const popupPaddleUpsellForm = $('.popup-paddle-content');
				if (popupPaddleUpsellForm.length > 0) {
					// scroll to upsell form
					$('html, body').animate({
						scrollTop: popupPaddleUpsellForm.offset().top
					}, 500);
					$this.removeClass('loading');
					return;
				}

				// script for paddle (they create a flow of additional sales)
				$this.hide();
				$.ajax({
					url: '/paddle/payment-page',
					data: params,
					success: function(html) {
						$this.after('<div class="popup-paddle-content"></div>');
						$('.popup-paddle-content').append(html);
						$this.removeClass('loading');
					},
					error: function() {
						handleFailedAction($this, 'upsell');
						w2w.showToast('Error during payment with Paddle', 'error');
						$this.removeClass('loading').show();
					}
				});

				return false;
			} else {
				// standard flow with subscription/upsell
			}
		}

		if (paymentMethod == 'solidgate') {
			params.header_accept = window.w2w_accept_page || ''
			params.header_accept_language = navigator.language;
			params.browser_color_depth = screen.colorDepth;
			params.browser_screen_height = screen.height;
			params.browser_screen_width = screen.width;
			params.browser_java_enabled = typeof navigator.javaEnabled === 'function' ? navigator.javaEnabled() : false;
			params.time_zone_offset = -new Date().getTimezoneOffset();
		}

		let showLoadingOverlay = $this.attr('data-show-loading-overlay');

		if (showLoadingOverlay === 'true') {
			w2w.showFullscreenOverlay(`
				<div id="loading-overlay" class="loading-overlay-container">
				<div class="mask"></div>
				<div class="type-button__spinner">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
						<circle transform-origin="center" fill="none" stroke="#FFFFFF" stroke-width="15"
								stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100"
								cy="100" r="70">
							<animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2"
											  values="360;0" keyTimes="0;1" keySplines="0 0 1 1"
											  repeatCount="indefinite"></animateTransform>
						</circle>
						<circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="15"
								stroke-linecap="round" cx="100" cy="100" r="70"></circle>
					</svg>
				</div></div>`
			);
		}

		fetch('/subscription/upsell', {
			method: 'POST',
			headers: {
				"Accept": "application/json",
				"Content-type": "application/json",
			},
			body: JSON.stringify(params)
		})
			.then(response => response.json())
			.then(async data => {
				if (data.success) {
					if (showLoadingOverlay === 'true') {
						w2w.showFullscreenOverlay(`
							<div id="loading-overlay" class="loading-overlay-container">
								<div class="type-button__success">
								<div class="mask"></div>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="140" height="140">
									<circle cx="100" cy="100" r="70" fill="#2eb87559"/>
									<path d="M 60 100 L 85 125 L 140 70" fill="none" stroke="#2eb875" stroke-width="12"
									stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</div>
							</div>`
						);
					}

					// 3DS authentication required for card 1-click upsell
					if (data?.verify_url) {
						window.location.href = data.verify_url;
						return false;
					}

					if (data.paypal == 1) {
						// script for paypal (they create a flow of additional sales)
						w2w.showToast(data.message, 'info');

						w2w.showPopup({
							content: '<div class="popup-paypal-content"></div>',
							buttons: [
								{
									text: __('Close'),
									action: () => w2w.hidePopup()
								}
							]
						});

						$.ajax({
							url: '/paypal/payment-page',
							data: params,
							success: function (html) {
								$('.popup-paypal-content').append(html);
								$this.removeClass('loading');
							},
							error: function () {
								w2w.showToast('Error with open paypal confirm form', 'error');

								w2w.hidePopup();

								$this.removeClass('loading')
								handleFailedAction($this, 'upsell');
							}
						})

						return false;
					}

					if (data.solidgate == 1) {
						// script for solidgate (they create a flow of additional sales)
						w2w.showToast(data.message, 'info')
						w2w.showPopup({
							content: '<div class="popup-solidgate-content"></div>',
							buttons: [
								{
									text: __('Close'),
									action: () => w2w.hidePopup()
								}
							]
						})

						if (data.additional_data?.wallet_method) {
							params.wallet_method = data.additional_data?.wallet_method;
						}

						$.ajax({
							url: '/solidgate/payment-page',
							data: params,
							success: function (html) {
								$('.popup-solidgate-content').append(html);
								$this.removeClass('loading');
							},
							error: function () {
								w2w.showToast('Error while opening Solidgate form', 'error');

								w2w.hidePopup();

								$this.removeClass('loading');
								handleFailedAction($this, 'upsell');
							}
						});

						return false;
					}

					// wait for created subscription from db (This is necessary so that after the redirect, the subscription is already in the database and all events are sent)
					if (data.paddle) {
						const paySystemId = data.paddle?.pay_system_id || ''
						try {
							const statusData = await waitSubscriptionCompleted(1, paySystemId, params.price_id);
						} catch (error) {
							// redirect for waiting payment page
							window.location.href = getPaymentUrl('/payment/processing', {checkPayment: 1, payment_system: 1, price_id: params.price_id, paywall_id: params.paywall_id, pay_system_id: paySystemId});
							return;
						}
					}


					let successMessage = $this.attr('data-success-message');
					let successMessageType = $this.attr('data-success-message-type');
					let successMessageSeconds = $this.attr('data-success-message-seconds') || 1;
					let timeout = 0;

					if (successMessage) {
						if (successMessageType === 'overlay') {
							w2w.showFullscreenOverlay(__(successMessage), successMessageSeconds);
						} else {
							w2w.showToast(__(successMessage), 'success', successMessageSeconds);
						}
						timeout = successMessageSeconds * 1000;
					}

					if (data.redirect) {
						if (showLoadingOverlay === 'true') {
							setTimeout(() => {
								$('#fullscreen-overlay').hide().html('');
							}, 1000);
						}
						setTimeout(() => window.location.href = data.redirect, timeout);
					} else {
						w2w.showToast(data.message, 'error');

						w2w.logEvent('Paywall Error One Click Buy', {value: data.message});

						$this.removeClass('loading');
						handleFailedAction($this, 'upsell');
					}
				} else {
					// Check if this is a double purchase error
					if (data.double_purchase_detected) {
						w2w.logEvent('Double purchase detected (One Click)', {
							behaviour: data.behaviour,
							existing_subscription_id: data.existing_subscription_id,
							price_id: priceId
						});

						// If there's a redirect URL - redirect the user
						if (data.redirect) {
							window.location.href = data.redirect;
						}
					} else if (data.message == 'insufficient_funds' && data.redirect) {
						// auto redirect
						window.location.href = data.redirect;
					} else {
						if (showLoadingOverlay === 'true') {
							$('#fullscreen-overlay').hide().html('');
						}

						w2w.showToast(data.message, 'error');

						w2w.logEvent('Paywall Error One Click Buy', {value: data.message});

						handleFailedAction($this, 'upsell');
					}
					$this.removeClass('loading');
				}
			})
			.catch(error => {
				if (showLoadingOverlay === 'true') {
					$('#fullscreen-overlay').hide().html('');
				}
				console.error('Error:', error);
				w2w.showToast(error.message || 'An error occurred', 'error');

				w2w.logEvent('Paywall Error One Click Buy', { value: error.message });

				$this.removeClass('loading');
				handleFailedAction($this, 'upsell');
			});
	});

	// ============================================================================
	// Update Subscription Button Handler
	// ============================================================================
	$(document).on('click', '[data-update-subscription-price-id]', function(e) {
		e.preventDefault();
		const $this = $(this);

		if ($this.hasClass('loading')) {
			return false;
		}

		let priceId = $this.attr('data-update-subscription-price-id');
		let subscriptionId = $this.attr('data-update-subscription-id');

		if (!priceId) {
			w2w.showToast(__('Please, set price ID for this button!'), 'error');
			return false;
		}

		if (!subscriptionId) {
			w2w.showToast(__('Please, set subscription ID for this button!'), 'error');
			return false;
		}

		if (priceId == 'selected') {
			priceId = localStorage.getItem('price_id');
		}
		// 'upgrade_price' / 'downgrade_price' placeholders are passed through as-is:
		// the backend resolves them from the current subscription price settings.

		$this.addClass('loading');

		const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

		let params = {
			_token: csrfToken,
			price_id: priceId,
			subscription_id: subscriptionId,
			paywall_id: window.paywall_id || '',
			customer_email: user_properties.email || '',
			quiz_id: getParams('quiz_id') || (window.user_properties ? window.user_properties.last_quiz_id : '') || '',
			quiz_version: getParams('quiz_version') || '',
		};

		if (getParams('test_project_id')) {
			params.test_project_id = getParams('test_project_id');
		}

		fetch('/subscription/update', {
			method: 'POST',
			headers: {
				"Accept": "application/json",
				"Content-type": "application/json",
			},
			body: JSON.stringify(params)
		})
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					let successMessage = $this.attr('data-success-message');
					let successMessageType = $this.attr('data-success-message-type');
					let successMessageSeconds = $this.attr('data-success-message-seconds') || 1;
					let timeout = 0;

					if (successMessage) {
						if (successMessageType === 'overlay') {
							w2w.showFullscreenOverlay(__(successMessage), successMessageSeconds);
						} else {
							w2w.showToast(__(successMessage), 'success', successMessageSeconds);
						}
						timeout = successMessageSeconds * 1000;
					} else {
						w2w.showToast(data.message || __('Subscription updated successfully'), 'success');
					}

					w2w.logEvent('Paywall Subscription Updated', {
						price_id: data.price_id || priceId,
						requested_price_id: priceId,
						subscription_id: subscriptionId
					});

					// Handle success action
					let successAction = $this.attr('data-success-action') || 'next_screen';
					let successActionUrl = $this.attr('data-success-action-url') || '';

					if (data.redirect) {
						// Server-provided redirect takes priority
						setTimeout(() => window.location.href = data.redirect, timeout);
					} else if (successAction === 'url' && successActionUrl) {
						// Go to URL or Screen
						setTimeout(() => {
							// Check if it's a screen ID (starts with #) or a URL
							if (successActionUrl.startsWith('#')) {
								// It's a screen ID, navigate to it
								screensManager.moveToSection(successActionUrl.replace('#', ''), 'success_action');

								setTimeout(function() {
									location.reload();
								}, 600);
							} else {
								// It's a URL, redirect to it
								window.location.href = successActionUrl;
							}
						}, timeout);
					} else {
						screensManager.moveToNextScreen()

						setTimeout(() => {
							location.reload();
						}, timeout || 1000);
					}
				} else {
					w2w.showToast(data.message || __('Failed to update subscription'), 'error');

					w2w.logEvent('Paywall Subscription Update Error', {
						value: data.message,
						price_id: priceId,
						subscription_id: subscriptionId
					});

					$this.removeClass('loading');
					handleFailedAction($this, 'update');
				}
			})
			.catch(error => {
				console.error('Error:', error);
				w2w.showToast(error.message || __('An error occurred while updating subscription'), 'error');

				w2w.logEvent('Paywall Subscription Update Error', {
					value: error.message,
					price_id: priceId,
					subscription_id: subscriptionId
				});

				$this.removeClass('loading');
				handleFailedAction($this, 'update');
			});
	});

})();
